export default __webpack_public_path__ + "static/media/logo-transparent.b3958bb6.png";